import $ from "jquery";


const appDownloadBanner = {

  method: {

     buttonClickHandler: function(){
       $('.app-download-banner').on('click','.app-download-banner--icons__img', function() {

          let link = $(this).closest('a');
          let section = $(this).closest('.app-download-banner--wrap');
          let titleText = section.find('.app-download-banner--title').text().trim();
          let buttonText = $(this).find('img').attr('alt');

          let obj = appDownloadBanner.method.dataLayerObj(buttonText,titleText);
          createDataLayer('buttonClick',obj);
       });
     },

     dataLayerObj: function (el,e) {
           var obj = {
             'articleName': "",
             'blogCategory': "",
             'blogPageCategory': "",
             'buttonText': el ? el : "",
             'pageSection': e ? e : "App Download Banner",
             'pageType': document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.length) === ".com/" ? "Home" : "Other Pages" : "Blog Details Page",
             'planOption': "",
             'productCategory': "",
             'productName': "",
             'question': "",
             'source': "",
             'searchTerm': "",
             'videoTitle': "",
             'bannerName': "",
           };
           return obj;
         }

  }

};

$(document).ready(function () {
  appDownloadBanner.method.buttonClickHandler();
});
